import { React, Styled } from '@common/3rd';
import { PageHeaderComponents } from '@my-types';
import Widget from '../widget';

/**
 * Page header
 */
class PageHeader<P, S, C extends PageHeaderComponents> extends Widget<P, S, C> {
	protected initComponents(): C {
		return {
			Box: Styled.div.attrs({
				'data-widget': 'page-header'
			})`
				z-index: ${props => props.theme.PAGE_HEADER_Z_INDEX};
			`
		} as C;
	}
	render() {
		const C = this.getComponents();
		return <C.Box />;
	}
}

export default PageHeader;
